import { createDocument, getAllData, updateDocumentByID } from 'apis/customApiHandler';
import Modal from 'components/Modal';
import Spinner from 'components/Spinner';
import Add from 'components/manage-dtp/add';
import useDebounce from 'hooks/useDebounce';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { BiCloudDownload } from 'react-icons/bi';
import { useQuery } from 'react-query';
import ReactSelect from 'react-select';
import { filterSelectStyles } from 'utils/reactSelectStyles';
import { Button, Input, Select } from 'styled';
import { TD, TH } from 'styled/table';
import getFormattedDate, { exportFile, formatDate } from 'utils/helpers';
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import ViewList from "../components/retread-request/viewList"
import { TableHeader } from 'components/retread-requests/TableHeader';
import exportExcel from 'utils/exportExcel';
import { ViewRetreadList } from 'components/retread-requests/ViewRetreadList';
import ViewInvoiceCost from 'components/retread-requests/ViewInvoiceCost';

  const RetreadApprove = () => {
    const [showAddmodel, setShowAddmodel] = useState(false);

    // Left blank on purpose: the fields show the browser's DD-MM-YYYY
    // placeholder until the user picks a range, and getData() only sends
    // dateFrom/dateTo when they are set.
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [allRetreadData, setRetreadData] = useState({})
    const [searchQuery, setSearchQuery] = useState("");
    const [fleetMap, setFleetMap] = useState({});
    const [selectedFleets, setSelectedFleets] = useState([]);
    const [selectedHubs, setSelectedHubs] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState([]);
    const [page, setPage] = useState(1);
    const [preview, setPreview] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const debouncedValue = useDebounce(searchQuery, 1000);
    const [search, setSearch] = useState("");
    const [downloading, setDownloading] = useState(false);
    const [consolidatedDownloading, setConsolidatedDownloading] = useState(false);
    const [approvedData, setApprovedData] = useState(null);
    const [approvalRemarks, setApprovalRemarks] = useState(null);
    const [modalData, setModalData] = useState(null);
    const [modalType, setModalType] = useState(null);
    const [selectedTyres, setSelectedTyres] = useState({});
    const [statusType, setStatusType] = useState("");
    const [tyreType, setTyreType] = useState("");
    const[showInvoiceCost,setShowInvoiceCost]=useState(null);  

    const { data: allFleets } = useQuery([`/customer-fleet`], () =>
      getAllData("/customer-fleet", {
        limit: 3000,
      })
    );
    const { data: allHubs } = useQuery([`/customer-hub`], () =>
      getAllData("/customer-hub", {
        limit: 3000,
      })
    );

    const { data: allVendor } = useQuery([`/vendor-contract/get-vendors`], () =>
      createDocument("/vendor-contract/get-vendors", {
        limit: 3000,
      })
    );

    const { data: requestData, refetch } = useQuery(
      [`/retread-request/${modalData?._id ?? approvedData?._id}`, approvedData?._id],
      () => getAllData(`/retread-request/${approvedData?._id}`),
      {
        enabled: !!approvedData,
      }
    );

    const getFleetOptions = useCallback(() => {
      if (allFleets && allFleets.data && allFleets.data.length) {
        return [
          {
            label: "All",
            value: "all",
          },
          {
            label: "Clear",
            value: "clear",
          },
          ...allFleets?.data?.map((fleet) => {
            return {
              value: fleet._id,
              label: fleet.fleetName,
            };
          }),
        ];
      }
    }, [allFleets]);

    const getHubOptions = useCallback(() => {
      if (allHubs && allHubs.data && allHubs.data.length) {
        return [
        ...selectedFleets?.length ? [{
            label: "All",
            value: "all",
          }]: [],
          ...selectedFleets?.length ? [{
            label: "Clear",
            value: "clear",
          }]: [],
          ...(selectedFleets?.includes("all") ?
            allHubs?.data?.length &&
            allHubs?.data
            ?.filter((hub) => hub.hubName?.trim())
              ?.map((hub) => {
                return {
                  value: hub._id,
                  label: hub.hubName,
                };
              }) :
            allHubs?.data?.length &&
            allHubs?.data
              ?.filter((hub) => {
                const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                );

                return(
                  hub.hubName?.trim() &&
                  selectedFleetsVal?.some(
                  (fleet) => fleet.fleetCode === hub.fleetCode
                  )
                );
              })
              ?.map((hub) => {
                return {
                  value: hub._id,
                  label: hub.hubName,
                };
              })),
        ];
      }
    }, [allFleets, allHubs, selectedFleets]);

    const getVendor = useCallback(() => {
      if (allVendor && allVendor.data && allVendor.data.length) {
        return [
          {
            label: "All",
            value: "all",
          },
          {
            label: "Clear",
            value: "clear",
          },
          ...allVendor?.data?.map((vendor) => {
            return {
              value: vendor._id,
              label: vendor.vendorName,
            };
          }),
        ];
      }
    }, [allVendor]);

    const getData = async (download = false, consolidatedDownload = false) => {
      if (consolidatedDownload) {
        setConsolidatedDownloading(true);
      } else if (download) {
        setDownloading(true);
      } else {
        setIsLoading(true);
      }
      try {

        const payload = {
          ...(selectedFleets?.includes("all")
            ? {
              fleets: getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
                .map((item) => item.value)
                .join(","),
            }
            : selectedFleets.length && {
              fleets: selectedFleets.map((fleet) => fleet).join(","),
            }),
          ...(selectedHubs?.includes("all")
            ? {
              hubs: getHubOptions().filter(item => item.value !== "all" && item.value !== "clear")
                .map((item) => item.value)
                .join(","),
            }
            : selectedHubs.length && {
              hubs: selectedHubs.map((hub) => hub).join(","),
            }),
          ...(selectedVendor?.includes("all")
            ? {
              vendors: getVendor().filter(item => item.value !== "all" && item.value !== "clear")
                .map((item) => item.value)
                .join(","),
            }
            : selectedVendor.length && {
              vendors: selectedVendor[0]?.value,
            }),
          ...(search && {
            searchQuery: search,
          }),
          ...(dateFrom && {
            dateFrom: dateFrom,
          }),
          ...(dateTo && {
            dateTo: dateTo,
          }),
          ...(statusType && {
            statusType: statusType,
          }),
          ...(tyreType && {
            tyreType: tyreType,
          }),
          page,
          download,
          limit: download ? undefined : 20,
        };

        const response = await createDocument('/retread-request/allRetreadRequest', payload);

        console.log('response.data--',response.data);

        if (consolidatedDownload && download && response?.data) {
          const consolidatedData = [];
          response.data.forEach((entry) => {
            if (entry?.tyres && entry.tyres.length > 0) {
              entry.tyres.forEach((tyre, index) => {
                consolidatedData.push({
                  "Request No": entry?.requestNo || "",
                  "Fleet Name": entry?.fleetName || "",
                  "Hub Name": entry?.hubName || "",
                  "Vendor Name": entry?.vendorName || "",
                  "Request By": entry?.requestBy || "",
                  "Request Date": entry?.requestDate || "",
                  "Current Status": entry?.status || "",
                  "Invoice Cost": index === 0 ? entry?.billInfo?.amount : "",
                  "Stencil No": tyre?.stencilNo || "",
                  "Tyre Type": tyre?.tyreType || "",
                  "Old Status": tyre?.oldStatus || "",
                  "Casing Type": tyre?.casingType || "",
                  "Brand": tyre?.brand || "",
                  "Tyre Size": tyre?.tyreSize || "",
                  "Avg NSD": tyre?.averageNSD || "",
                  "Km Travelled": tyre?.totalKillometerTravelled || "",
                  "Tyre Status": tyre?.status || "",
                  "Action": tyre?.approvedForRetread ? "Approved" : "Not Approved",
                });
              });
            } else {
              // If no tyres, still add the request row
              consolidatedData.push({
                "Request No": entry?.requestNo,
                "Fleet Name": entry?.fleetName,
                "Hub Name": entry?.hubName,
                "Vendor Name": entry?.vendorName,
                "Requested By": entry?.requestBy,
                "Request Date": entry?.requestDate,
                "Current Status": entry?.status,
                "Invoice Cost": entry?.billInfo?.amount,
                "Number Of Tyres": entry?.numberOfTyres || 0,
                "Stencil No": "",
                "Tyre Type": "",
                "Old Status": "",
                "Casing Type": "",
                "Brand": "",
                "Tyre Size": "",
                "Avg NSD": "",
                "Km Travelled": "",
                "Tyre Status": "",
                "Actions": "",
              });
            }
          });
          
          exportExcel(
            consolidatedData,
            "rethread-request-consolidated"
          );
          setConsolidatedDownloading(false);
        } else if (download && response?.data) {
          exportExcel(
            response.data.map((entry) => ({
              "Request No": entry?.requestNo,
              "Fleet Name": entry?.fleetName,
              "Hub Name": entry?.hubName,
              "Number Of Tyres": entry?.numberOfTyres,
              "Requested By": entry?.requestBy,
              "Request Date": entry?.requestDate,
              "Vendor Name": entry?.vendorName,
              "Current Status": entry?.status,
              "Invoice Cost": entry?.billInfo?.amount,
            })),
            "rethread-request"
          );
          setDownloading(false);
        } else {
          setRetreadData(response);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        if (!download && !consolidatedDownload) {
          setIsLoading(false);
        } else if (download && !consolidatedDownload) {
          setDownloading(false);
        } else if (consolidatedDownload) {
          setConsolidatedDownloading(false);
        }
      }
    }

    useEffect(() => {
      if (selectedHubs?.length || selectedFleets?.length)
        getData()
    }, [page])

    const updateApprovalRecord = async (id, status, data = {}) => {

      const tyresPayload = requestData.data.tyres.map((tyre) => ({
        _id: tyre._id,
        approvedForRetread: !!selectedTyres[tyre._id],
      }));

      const myPromise = updateDocumentByID("retread-request/approve", id, {
        status: status,
        tyres: tyresPayload,
        ...(data && { ...data }),
      });
      refetch();
      toast.promise(myPromise, {
        loading: "Updating your request",
        success: (dt) => {
          if (search || selectedHubs?.length || selectedHubs?.length) getData();
          return dt.message;
        },
        error: (err) =>
          err?.response?.data.error ||
          err?.response?.data.message ||
          err?.message ||
          "Something went wrong",
      });
    };

    const updateRejectRecord = async (id, status, data = {}) => {
      const myPromise = updateDocumentByID("retread-request/reject", id, {
        status: status,
        ...(data && { ...data }),
      });

      toast.promise(myPromise, {
        loading: "Updating your request",
        success: (dt) => {
          if (search || selectedHubs?.length || selectedHubs?.length) getData();
          return dt.message;
        },
        error: (err) =>
          err?.response?.data.error ||
          err?.response?.data.message ||
          err?.message ||
          "Something went wrong",
      });
    };

    const updateInvoiceStatus = async (id, status, data = {}) => {
      const myPromise = updateDocumentByID("retread-request/update", id, {
        status: status,
      });
      // refetch();
      toast.promise(myPromise, {
        loading: "Updating your request",
        success: (dt) => {
          if (search || selectedHubs?.length || selectedHubs?.length) getData();
          return dt.message;
        },
        error: (err) =>
          err?.response?.data.error ||
          err?.response?.data.message ||
          err?.message ||
          "Something went wrong",
      });
    };

  const handleSelectionChange = (tyreId, checked) => {
    setSelectedTyres((prevSelectedTyres) => ({
      ...prevSelectedTyres,
      [tyreId]: checked,
    }));
  };

  console.log('requestData--',requestData);

  return (
    <div>
      
      <div className="mx-10 my-2 mb-5">

        <div className="mt-8 grid grid-cols-6 justify-start items-end gap-2">
          
          <div className="grid grid-cols-8 col-span-6 items-end gap-x-2">

            <label className="w-full py-3 col-span-2 flex flex-col gap-2">
              Select Fleets
              <ReactSelect
                styles={filterSelectStyles}
                className="shadow-md rounded-md"
                options={getFleetOptions()}
                value={
                  selectedFleets &&
                  selectedFleets?.map((fleet) => {
                    return {
                      value: fleet,
                      label: getFleetOptions()?.find((item) => item?.value === fleet)
                        ?.label,
                    };
                  })
                }
                onChange={(value) => {
                  let allValues = value?.map((item) => item.value);
                  if (allValues?.includes("clear")) {
                    setSelectedFleets([]);
                    setSelectedHubs([]);
                    return;
                  }
                  if (!selectedFleets?.includes("all") && allValues.includes("all")) {
                    setSelectedFleets(["all"]);
                    return;
                  }

                  if (selectedFleets.includes("all")) {
                    value = value.filter(item => item.value !== "all")
                  }

                  let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                    value?.map((item) => item.value)?.includes(fleet._id)
                  );

                  let selectedHubsVal = allHubs?.data?.filter((hub) =>
                    selectedHubs?.map((item) => item)?.includes(hub._id)
                  );

                  setSelectedHubs(
                    selectedHubsVal
                      ?.filter((hub) =>
                        selectedFleetsVal?.find(
                          (fleet) => fleet.fleetCode === hub.fleetCode
                        )
                      )
                      .map((hub) => hub._id)
                  );

                  setSelectedFleets(value.map((fleet) => fleet.value));
                }
                }
                name="fleets"
                isMulti={true}
              />
            </label>

            <label className="w-full py-3 col-span-2 flex flex-col gap-2">
              Select Hubs
              <ReactSelect
                styles={filterSelectStyles}
                className="shadow-md rounded-md"
                options={getHubOptions()}
                value={
                  selectedHubs &&
                  selectedHubs?.map((hub) => {
                    return {
                      value: hub,
                      label: getHubOptions()?.find((item) => item.value === hub)
                        ?.label,
                    };
                  })
                }
                onChange={(value) => {
                  const allValues = value?.map((item) => item.value);
                  if (allValues.includes("clear")) {
                    setSelectedHubs([])
                    return;
                  }
                  if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                    let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                      selectedFleets?.includes(fleet._id)
                    )?.map(fleet => fleet.fleetCode);

                    const selectedHubsData = allHubs?.data?.filter(hub => selectedFleetCodes?.includes(hub.fleetCode))

                    const mp = fleetMap;
                    selectedHubsData.map(hub => {
                      if (selectedFleetCodes?.includes(hub.fleetCode)) {
                        if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                      }
                    })

                    setFleetMap(mp);
                    setSelectedHubs(["all"])
                  }
                  else {
                    value = value.filter(value => value.value !== "all")
                    let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                      selectedFleets?.includes(fleet._id)
                    )?.map(fleet => fleet.fleetCode);

                    const selectedHubsData = allHubs?.data?.filter(hub => allValues?.includes(hub._id))
                    const mp = {};
                    selectedHubsData.map(hub => {
                      mp[hub.fleetCode] = [];
                    })

                    selectedHubsData.map(hub => {
                      if (selectedFleetCodes?.includes(hub.fleetCode)) {
                        if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                      }
                    })

                    setFleetMap(mp);
                    setSelectedHubs(value.map((hub) => hub.value));
                  }
                }}
                name="hubs"
                isMulti={true}
              />
            </label>

            <label className="w-full py-3 col-span-2 flex flex-col gap-2">
              Select Vendor
              <ReactSelect
                styles={filterSelectStyles}
                className="shadow-md rounded-md"
                options={getVendor()}
                value={
                  selectedVendor && selectedVendor.length > 0
                    ? selectedVendor?.map((vendor) => {
                      if (vendor === "all") {
                        return { value: "all", label: "All" };
                      }
                      return {
                        value: vendor?.value,
                        label: vendor?.label,
                      };
                    })
                    : null
                }

                onChange={(value) => {
                  let allValues = value?.map((item) => item.value);

                  if (allValues.includes("clear")) {
                    setSelectedVendor([]);
                    return;
                  }

                  if (allValues.includes("all")) {
                    const allVendorIds = getVendor()?.map((vendor) => vendor.value);
                    setSelectedVendor(["all"]);
                    return;
                  }

                  setSelectedVendor(value.map((vendor) => ({ value: vendor.value, label: vendor.label })));
                }
                }
                name="vendor"
                isMulti={true}
              />
            </label>

            <label className="w-full py-3 col-span-2 flex flex-col gap-2">
                Status
                <Select
                  name="statusType"
                  value={statusType}
                  onChange={(e) => setStatusType(e.target.value)}
                >
                  <option value={""}>All</option>
                  <option value={"Requested"}>Requested</option>
                  <option value={"Approved"}>Approved</option>
                  <option value={"Dispatched to Vendor"}>Dispatched to Vendor</option>
                  <option value={"In Retread"}>In Retread</option>
                  <option value={"Dispatched to Hub"}>Dispatched to Hub</option>
                  <option value="Completed">Completed</option>

                </Select>
              </label>

            </div>     

          <div className="grid grid-cols-8 col-span-6 items-end gap-x-2">

            <label className="w-full py-3 col-span-2 flex flex-col gap-2">
                Tyre Type
                <Select
                  name="tyreType"
                  value={tyreType}
                  onChange={(e) => setTyreType(e.target.value)}
                >
                  <option value={""}>All</option>
                  <option value={"CTR"}>CTR</option>
                  <option value={"RTD"}>RTD</option>
                </Select>
              </label>

            <label className="w-full py-3 col-span-2 flex flex-col gap-2">
              Search
              <Input
                type="search"
                placeholder="Search Here"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setPage(1);
                    getData();
                  }
                }}
              />
            </label>

            <label className="w-full py-3 col-span-2 flex flex-col gap-2">
              Start Date{" "}
              <Input
                type="date"
                max={getFormattedDate()}
                name="dateFrom"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
              />
            </label>

            <label className="w-full py-3 col-span-2 flex flex-col gap-2">
              End Date{" "}
              <Input
                type="date"
                // getFormattedDate() falls back to today for a blank input, so
                // only constrain the end date once a start date is chosen.
                min={dateFrom ? getFormattedDate(dateFrom) : undefined}
                max={getFormattedDate()}
                name="dateTo"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
              />
            </label>


         


          </div>

        </div>

        <div className="w-[99%] py-3 col-span-2 mt-5 mx-8 flex justify-end">

        <div className="flex flex-row flex-wrap justify-end gap-3"
        >
          <Button
            type="button"
            bgPrimary
            onClick={async () => {
              setPage(1);
              await getData();
            }}
            disabled={
              selectedHubs.length === 0 &&
              !search
            }
          >
            Search
          </Button>

          {downloading
            ? "Downloading..."
            : !(
              selectedHubs.length === 0 &&
              !search
            ) && (
              <Button
                type="button"
                bgPrimary
                className="p-2"
                onClick={() => getData(true, false)}
              >Download Data</Button>
            )}

          {consolidatedDownloading
            ? "Downloading Consolidated..."
            : !(
              selectedHubs.length === 0 &&
              !search
            ) && (
              <Button
                type="button"
                bgPrimary
                className="p-2"
                onClick={() => getData(true, true)}
              >Download Consolidated Data</Button>
            )}

        </div>

</div>

      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col" className="!text-center whitespace-nowrap">S.N.</TH>
                      <TH scope="col" className="!text-center whitespace-nowrap">Request No</TH>
                      <TH scope="col" className="!text-center whitespace-nowrap">Fleet Name</TH>
                      <TH scope="col" className="!text-center whitespace-nowrap">Hub Name</TH>
                      <TH scope="col" className="!text-center whitespace-nowrap">No of tyres</TH>
                      <TH scope="col" className="!text-center whitespace-nowrap">Request by</TH>
                      <TH scope="col" className="!text-center whitespace-nowrap">Request Date</TH>
                      <TH scope="col" className="!text-center whitespace-nowrap">Vendor Name</TH>
                      <TH scope="col" className="!text-center whitespace-nowrap">Status</TH>
                      <TH scope="col" className="!text-center whitespace-nowrap">Invoice cost</TH>
                      <TH scope="col" className="!text-center whitespace-nowrap">Action</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {allRetreadData?.data &&
                      allRetreadData?.data.map((data, index) => (
                        <ViewList data={data} key={data._id} index={index} getData={getData} page={page} approvedData={approvedData} setApprovedData={setApprovedData} updateApprovalRecord={updateApprovalRecord} updateRejectRecord={updateRejectRecord}
                          setModalData={setModalData} setModalType={setModalType} setShowInvoiceCost={setShowInvoiceCost}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {allRetreadData?.data?.length > 0 && (
        <div className="container mx-auto flex justify-center items-center gap-2 py-5">
          <Button
            onClick={() => {
              setPage((p) => Math.max(p - 1, 1));
            }}
            disabled={page === 1}
            className="disabled:pointer-events-none disabled:opacity-70 px-0 "
            primary
          >
            <div className="flex gap-1 items-center">
              <IoMdArrowBack />
              Prev Page
            </div>
          </Button>

          <span className="text-gray-600 px-4">{`showing: ${(page - 1) * 20 + 1
            } - ${Math.min(allRetreadData?.paginate?.total, page * 20)} of ${allRetreadData?.paginate.total
            }`}</span>

          {allRetreadData?.paginate.total > page * 20 && (
            <Button
              onClick={() => {
                setPage((p) => Math.min(p + 1, allRetreadData?.paginate?.total));
              }}
              disabled={page === allRetreadData?.paginate?.totalPage}
              className="disabled:pointer-events-none disabled:opacity-70 px-0 "
              primary
            >
              <div className="flex gap-1 items-center">
                Next Page
                <IoMdArrowForward />
              </div>
            </Button>
          )}
        </div>
      )}

      {modalType === "tyres" && (
        <Modal
          handleClick={() => {
            setModalData(null);
            setModalType(null);
          }}
          title="Retread Request Info"
        >
          <p className=" text-medium font-semibold bg-gray-100 rounded-md p-2 m-2  text-center">
            {requestData?.data?.remark ?? "N/A"}
            {/* {requestData?.data?.approvalRemarks ? requestData?.data?.approvalRemarks : requestData?.data?.rejectionRemarks ? requestData?.data?.rejectionRemarks : "N/A"} */}
          </p>

          <div className="overflow-x-scroll">
            <table className="min-w-full divide-y divide-gray-200">
              <TableHeader modalType={modalType}/>
              <tbody className="bg-white divide-y divide-gray-200">
                {requestData?.data?.tyres?.map((item, index) => {
                  return <ViewRetreadList tyreData={item} requestData={requestData?.data} index={index} 
                  onSelectionChange={handleSelectionChange} selectedTyres={selectedTyres} modalType={modalType}
                  />
                })}
              </tbody>
            </table>
          </div>

          <div className="flex flex-col m-2 lg:m-2">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr className="py-2">
                        <TH scope="col">Action</TH>
                        <TH scope="col">By</TH>
                        <TH scope="col">On</TH>
                        <TH scope="col">Remarks</TH>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                    {requestData?.data?.createdBy && (
                        <tr className="bg-gray-100 h-10">
                          <TD>Requested</TD>
                          <TD>{requestData?.data?.createdBy?.name}</TD>
                          <TD>{getFormattedDate(requestData?.data?.requestDate, "/")}</TD>
                          <TD >{requestData?.data?.remark ?? "----"}</TD>
                        </tr>
                      )}
                      {requestData?.data?.approvedBy && (
                        <tr className="bg-gray-100 h-10">
                          <TD>Approval</TD>
                          <TD>{requestData?.data?.approvedBy?.name}</TD>
                          <TD>{getFormattedDate(requestData?.data?.approvedAt, "/")}</TD>
                          <TD>{requestData?.data?.approvalRemarks}</TD>
                        </tr>
                      )}
                      {requestData?.data?.dispatchedBy && (
                        <tr className="bg-gray-100 h-10">
                          <TD>Dispatched</TD>
                          <TD>{requestData?.data?.dispatchedBy?.name}</TD>
                          <TD>{getFormattedDate(requestData?.data?.dispatchDate, "/")}</TD>
                          <TD>{requestData?.data?.dispatchRemarks ?? "----"}</TD>
                        </tr>
                      )}
                      {requestData?.data?.completedBy && (
                        <tr className="bg-gray-100 h-10">
                          <TD>Completed</TD>
                          <TD>{requestData?.data?.completedBy?.name}</TD>
                          <TD>{getFormattedDate(requestData?.data?.completedAt, "/")}</TD>
                          <TD>{requestData?.data?.completedRemarks}</TD>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </Modal>
      )}

      {showAddmodel && (
        <Add
          handleClick={() => {
            setShowAddmodel(false);
          }}
        />
      )}

      {preview &&
        <Modal
          handleClick={(e) => { setPreview(null) }}>
          <div>
            <iframe className={preview.fileType} width="100%" height="800" frameborder="0" src={`${preview.url}`}></iframe>
          </div>
        </Modal>}

      {modalType === "approval" && (
        <Modal
          handleClick={() => {
            setModalType(null);
          }}
          title="Retread Request Approval"
        >
          <div className="p-4 overflow-x-hidden">
            <div className="mb-2">
              Request to retread {requestData?.data?.tyres?.length} tyre(s) has been created by {requestData?.data?.createdBy?.name} for
              {" "}{requestData?.data?.fleet?.fleetName} - {requestData?.data?.hub?.hubName} to {requestData?.data?.vendor?.vendorName}. Please find the details below:
            </div>
            <p className=" text-medium font-semibold bg-gray-100 rounded-md p-2 m-2  text-center">
              {requestData?.data?.remark ?? "N/A"}
            </p>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <TableHeader />
                <tbody className="bg-white divide-y divide-gray-200">
                  {requestData?.data?.tyres?.map((item, index) => {
                    return <ViewRetreadList tyreData={item} requestData={requestData?.data} index={index} onSelectionChange={handleSelectionChange}
                    selectedTyres={selectedTyres} modalType={modalType}
                    />
                  })}
                </tbody>
              </table>
            </div>

            <textarea
              className={` w-full rounded-md py-2 px-3  my-2 text-gray-500  focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 border border-gray-300 border-1`}
              type="text"
              maxLength={150}
              placeholder="Enter remarks for approval (max 150 chars)"
              onChange={(e) => {
                setApprovalRemarks(e.target.value);
              }}
            />

          </div>
          
          <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
            <Button
              bgSecondary
              onClick={() => {
                setApprovedData(null)
                setApprovalRemarks(null)
                setModalData(null);
                setModalType(null);
              }}
            >
              Cancel
            </Button>
            <Button
            disabled={!approvalRemarks?.length || !Object.values(selectedTyres).some((checked) => checked)}
              bgPrimary
              onClick={async () => {
                await updateApprovalRecord(approvedData?._id, "APPROVED", {
                  approvalRemarks
                });
                setApprovedData(null)
                setApprovalRemarks(null)
                setModalData(null);
                setModalType(null);
              }}
            >
              {"Approve"}
            </Button>
          </div>
        </Modal>
      )}

      {(modalType === "Completed" || modalType === "Invoice Rejected" )&& (
        <Modal
          handleClick={() => {
            setModalType(null);
            setModalData(null)
          }}
          title="Retread Request"
        >
          <div className="p-4 overflow-x-hidden">
          Are you sure you want to mark this request as: 
          <span className='text-bold'>
            {" "}{modalType}
          </span>
            {/* <textarea
              className={` w-full rounded-md py-2 px-3  my-2 text-gray-500  focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 border border-gray-300 border-1`}
              type="text"
              maxLength={150}
              placeholder="Enter remarks for approval (max 150 chars)"
              onChange={(e) => {
                setApprovalRemarks(e.target.value);
              }}
            /> */}

          </div>

          <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
            <Button
              bgSecondary
              onClick={() => {
                setApprovedData(null)
                setApprovalRemarks(null)
                setModalData(null);
                setModalType(null);
              }}
            >
              Cancel
            </Button>
            <Button
              // disabled={!approvalRemarks?.length || !Object.values(selectedTyres).some((checked) => checked)}
              bgPrimary
              onClick={async () => {
                await updateInvoiceStatus(modalData?._id, modalType);
                setApprovedData(null)
                setApprovalRemarks(null)
                setModalData(null);
                setModalType(null);
              }}
            >
              {"Submit"}
            </Button>
          </div>
        </Modal>
      )}

      { showInvoiceCost && (
        <ViewInvoiceCost
        billInfo={showInvoiceCost}
        handleClick={() => setShowInvoiceCost(null)}
        />
      )}

    </div>
  );
};

export default RetreadApprove;
